import { a as autoUpdate, c as computePosition, o as offset, f as flip, s as size } from './floating-ui.dom-SMWHQ3Bc.js';
import { D as DialogExt } from './dialog-nybQUbi-.js';
import './bodyScrollLock-BdpZ2Ojz.js';
import './pubsub-COBwjfLh.js';
import './notyf-DIw0RvBj.js';

class DropdownElement extends DialogExt {
  #button = this.controllers?.[0] ?? null;
  #body = this.querySelector('[data-dropdown-body]');
  #backdrop = this.querySelector('.backdrop');
  /** @type {(() => void) | null} */ #cleanupPosition = null;

  connectedCallback() {
    if (super.connectedCallback()) return;
    if (!this.#button || !this.#body) return;

    this.#backdrop?.addEventListener('click', () => this.close());

    // Sync panel visibility with host aria-hidden (backdrop uses in-aria-hidden:*)
    new MutationObserver(() => {
      this.#body.ariaHidden = this.ariaHidden;

      if (this.ariaHidden === 'true') {
        this.#cleanupPosition?.();
        this.#cleanupPosition = null;
      }
    }).observe(this, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  open() {
    this.#cleanupPosition = autoUpdate(this.#button, this.#body, () => this.#updatePosition());
    this.#body.ariaHidden = 'false';
    super.open();
  }

  close() {
    this.#body.ariaHidden = 'true';
    super.close();
    this.#cleanupPosition?.();
    this.#cleanupPosition = null;
  }

  #updatePosition() {
    const padding = 16;
    const placement = this.dataset.dropdownPlacement || 'bottom-end';

    computePosition(this.#button, this.#body, {
      placement,
      middleware: [
        offset(8),
        flip({ padding }),
        size({
          padding,
          apply({ availableHeight, elements }) {
            Object.assign(elements.floating.style, {
              maxHeight: `${Math.max(120, Math.min(availableHeight, 320))}px`,
            });
          },
        }),
      ],
      strategy: 'fixed',
    }).then(({ x, y }) => {
      Object.assign(this.#body.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  }
}

customElements.define('dropdown-element', DropdownElement);
